import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	selectedNotificationFilterType: '',
	isShowDesingList: false,
	selectedCardOption: null
};

export const myDashboardSlice = createSlice({
	name: 'myDashboardSlice',
	initialState,
	reducers: {
		setSelectedNotificationFilterType: (state, action) => {
			state.selectedNotificationFilterType = action.payload;
		},
		setIsShowDesignList: (state, action) => {
			state.isShowDesingList = action.payload;
		},
		setSelectedCardOption: (state, action) => {
			state.isShowDesingList = true;
			state.selectedCardOption = action.payload;
		}
	}
});

export const { setSelectedNotificationFilterType, setIsShowDesignList, setSelectedCardOption } =
	myDashboardSlice.actions;

export default myDashboardSlice.reducer;
